import React from 'react';
import {
  Player,
  PlayerPair,
  EmptyPlayer,
  EmptyPlayerSlot,
  PlayersCount,
  PlayersCountNoNum,
  PlayersInner,
  PlayersList,
  PlayersPairs,
  NoPlayersMessage,
  ActionButton,
  LoginButton,
  NoActionButton,
  GamePlayers,
  KingOfTheHillPlayers,
  KingOfTheHillPrePlayers,
  MorningOpenPlayers,
  MorningOpenPrePlayers,
  RandomRelationsPlayers,
  RandomRelationsResults,
  RandomRelationsPrePlayers,
  RandomRelationsMiniPlayers,
  TrainingQueue,
  GameDetailsInnerSummary,
  AlertInfo,
  AlertDanger,
  AlertPrepayment,
  AlertAfterReg,
  AlertTraining
} from './final.js';

class KingOfTheHillResults extends React.Component {
  players = () => {
    if (this.props.flag === "medals") {
      return (
        <PlayersPairs
          label={"Победители"}
          players={this.props.game.playersWithMedals}
        />
      )
    } else {
      return (
        <PlayersPairs
          label={"Участники без медалей"}
          players={this.props.game.playersWithoutMedals}
        />
      )
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.players()}
      </React.Fragment>
    )
  }
}

export default KingOfTheHillResults;
